module.exports = __webpack_public_path__ + "assets/235338a3ed415527c55c6deaaa58fe70.mp4";